import { inject, observer } from "mobx-react";
import * as React from "react";
import { ChevronLeft } from "react-feather";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { CardBody, CardHeader, Col, Row } from "reactstrap";
import { Spinner } from "../../components";
import VisitsStore from "./VisitsStore";
import { VisitPictureResponseV1, VisitPictureType } from "./VisitPicturesApi";

function ImageGrid({ images = [] }: { images?: VisitPictureResponseV1[] }) {
  if (!images.length) return null;
  console.log(VisitPictureType[0]);
  console.log(VisitPictureType[1]);
  console.log(VisitPictureType[2]);
  console.log(VisitPictureType[3]);
  return (
    <Row>
      {images.map((image) => (
        <Col key={image.pictureId} xs="6" sm="4" md="3" className="mb-3">
          <div className="img-tile-wrap">
            <img src={image.imageUri} alt={""} className="img-tile" />
            <span className="img-type-badge">
              {VisitPictureType[image.visitPictureType]}
            </span>
          </div>
        </Col>
      ))}
    </Row>
  );
}

interface InjectedProps extends IProps {
  visitsStore: VisitsStore;
}

interface IProps extends WithTranslation {}

@inject("visitsStore")
@observer
class VisitPicturesPageContent extends React.Component<
  InjectedProps & RouteComponentProps<{ visitId: string }>,
  {}
> {
  private get injectedprops() {
    return this.props as InjectedProps;
  }
  public async componentWillMount() {
    this.injectedprops.visitsStore.signalIsGettingItems();
  }
  public async componentDidMount() {
    await this.injectedprops.visitsStore.getVisitAndDetails(
      this.props.match.params.visitId
    );
    await this.injectedprops.visitsStore.getVisitPictures(
      this.props.match.params.visitId
    );
  }

  private goBack = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    this.props.history.push(this.props.visitsStore.currentVisitUrl);
  };
  public render() {
    const t = this.props.t;

    console.log();
    return (
      <>
        <CardHeader>
          <a
            href={this.props.visitsStore.currentVisitUrl}
            style={{ marginLeft: "-10px" }}
            onClick={this.goBack}
          >
            <ChevronLeft />
            {t("back")}
          </a>
          <h2 style={{ marginTop: "15px" }}>{t("title")}</h2>
        </CardHeader>
        <CardBody>
          {this.injectedprops.visitsStore.isGettingItems === true && (
            <Spinner />
          )}
          {this.injectedprops.visitsStore.isGettingItems === false &&
            this.injectedprops.visitsStore.selectedItem === null && (
              <h2>{t("common:notfound")}</h2>
            )}
          {this.injectedprops.visitsStore.visitPictures.length > 0 && (
            <ImageGrid images={this.injectedprops.visitsStore.visitPictures} />
          )}
        </CardBody>
      </>
    );
  }
}

const VisitPicturesPage = withTranslation("visitPictures")(
  VisitPicturesPageContent
);

export { VisitPicturesPage };
